import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useCallback } from "react";
import { IMaskInput } from "react-imask";

/**
 * MaskedInputBase
 */

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const MaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});

/**
 * MaskedInput
 */

type Props = {
  name: string,
  label: string,
  error?: boolean,
  helperText?: string,
  mask: any,
  maskPlaceholder: string,
  value?: string | null,
  onChange: (value: string) => void,
};

export const MaskedInput = ({
  name,
  label,
  error,
  helperText,
  mask,
  maskPlaceholder,
  value,
  onChange,
}: Props) => {
  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  }, [
    onChange,
  ]);

  return (
    <FormControl variant="outlined" size="small">
      <InputLabel htmlFor={`input-${name}`} shrink={true} size="small" error={error}>{label}</InputLabel>
      <OutlinedInput
        size="small"
        id={`input-${name}`}
        name={name}
        value={value}
        label={label}
        notched={true}
        error={error}
        aria-describedby={`${name}-component-error-text`}
        onChange={handleChange}
        inputComponent={MaskedInputBase as any}
        inputProps={{
          mask: mask,
          placeholder: maskPlaceholder,
        }} />

      <FormHelperText id={`${name}-component-error-text`} error={helperText !== undefined}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}